<template>
  <customer-form-component
    mode="create"
    @submit="onSubmit"
    :error="responseError"
    :loading="loading">

  </customer-form-component>
</template>

<script>
  import {customerService} from "../../../services/CustomerService.class";
  import CustomerFormComponent from './CustomerForm';

  // const mspStateMappers = createNamespacedHelpers('msp');

  export default {
    name: "EditCustomer",
    components: {CustomerFormComponent},
    data() {
      return {
        loading: false,
        customer: null,
        responseError: '',
      }
    },
    mounted() {
    },
    methods: {
      onSubmit(customer) {
        this.loading = true;
        customerService.create(customer).then(() => {
          this.$message.info("Kunde Erstellt");
          setTimeout(() => this.$router.replace({path: '/app/settings'}), 200);
        }).catch((error) => {
          if (error.response.status === 409) {
            this.responseError = 'Name oder Domain existiert bereits';
            this.$message({
              message: this.$t('settings.customerExists'),
              type: 'error',
              duration: 10000,
            });
          } else {
            this.$message({
              message: this.$t('settings.genericHttpError'),
              type: 'error',
              duration: 10000,
            });
          }

        }).finally(() => {
          this.loading = false;
        });
      }
    },
  }

</script>

<style scoped lang="scss">
  .customer-general-settings-wrap {
    display: flex;
    align-items: center;

  }

  .form-separator {
    margin-left: 64px;
    margin-right: 64px;
  }

  .customer-name-header {
    font-weight: 200;
    color: gray;
  }

  .customer-edit-form-part {
    display: flex;
    flex-flow: row wrap;

    .el-form-item {
      flex: 40%;
      padding: 0 5px 0 5px;
      min-width: 600px;
    }
  }
</style>
